import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing a historical cash flow view.
 * @extends JetView
 */
export default class tableHistoricalCashFlowView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} Configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function

        // Custom data filter for summing tree column
        webix.ui.datafilter.summTreeColumn = webix.extend(
            {
                /**
                 * Refreshes the filter display with the summed value.
                 * @param {Object} master - The master data view.
                 * @param {Object} node - The node to update.
                 * @param {Object} value - The value to sum.
                 */
                refresh: function (master, node, value) {
                    var result = 0; // Initialize result
                    var resultFormat = 0; // Initialize formatted result
                    master.data.each(function (obj) {
                        if (obj.$level == 1) result += obj[value.columnId]; // Sum values at level 1
                    });
                    // Format result based on column type
                    if (value.columnId === 'CantidadTickets') {
                        resultFormat = webix.i18n.intFormat(result);
                    } else {
                        resultFormat = webix.i18n.priceFormat(result);
                    }
                    node.firstChild.innerHTML = resultFormat; // Update node display
                },
            },
            webix.ui.datafilter.summColumn, // Extend existing summColumn filter
        );

        return {
            view: 'treetable', // Define view type
            scheme: {
                $group: {
                    by: 'Grouper', // Grouping configuration
                },
            },
            bready: function () {
                this.openAll(); // Automatically open all groups
            },
            footer: true, // Enable footer
            columns: [
                // Define columns for the tree table
                {
                    id: 'Id',
                    header: 'Id',
                    width: 250,
                    /**
                     * Template for rendering Id column.
                     * @param {Object} obj - The data object.
                     * @param {Object} common - Common utilities.
                     * @returns {String} Rendered Id or group value.
                     */
                    template: function (obj, common) {
                        if (obj.$group) return common.treetable(obj, common) + obj.value; // Render group value
                        return obj.Id; // Render Id
                    },
                },
                { id: 'Description', header: _('Descripción'), width: 300 }, // Description column
                { id: 'Type', header: _('Tipo Establecimiento'), width: 300 }, // Type column
                { id: 'IsActivate', header: _('Estado'), width: 300 }, // Activation status column
            ],
            autowidth: false, // Disable auto width
            data: [
                // Initial data for the table
                {
                    Id: '1',
                    Description: 'Metodo de pago',
                    Type: 'Tipo Establecimiento',
                    IsActivate: 'A',
                    Grouper: 'Tipo Establecimiento',
                },
                {
                    Id: '2',
                    Description: 'Residencia',
                    Type: 'Tipo Punto',
                    IsActivate: 'A',
                    Grouper: 'Tipo Punto',
                },
                {
                    Id: '3',
                    Description: 'Regional Generica',
                    Type: 'Regional',
                    IsActivate: 'A',
                    Grouper: 'Regional',
                },
            ],
            math: true, // Enable mathematical operations
            datafetch: 10, // Number of records to fetch
            pager: 'pagerA', // Pager configuration
        };
    }

    /**
     * Initializes event listeners for the view.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        // Event listener for filtering data
        this.on(this.app, 'qualifying:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize query string
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to query
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to query
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Parse start date
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add formatted start date to query
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Parse end date
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add formatted end date to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            console.log(string1); // Log the constructed query string
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + string1, // Load data with constructed query
            );
        });

        // Event listener for item click
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user id event
        });

        // Event listener for player selection
        this.on(this.app, 'player:select', (Id) => {
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load data filtered by PlayerId
            );
        });
    }
}

// FILE DOCUMENTED
